import { useEffect, useState } from "react";
import "./wizard.css";

const TinyProgressBar = ({steps, progress, size, circleSize, finished, ...props}) => {
    const [circleStyles, setCircleStyles] = useState([]);
    const [textStyles, setTextStyles] =  useState([]);
    const [lineWidth, setLineWidth] =  useState("0%");
    const fontSize = size || "0.6rem";
    const fontCircleSize = circleSize || "0.5rem";

    useEffect(() => {
        if(!steps || steps.length === 0)
            return;
        const total = steps.length;
        let _progress = 0;
        
        const fontCompleted = {color: "rgb(33, 150, 243)",fontSize:fontSize}
        const fontUncompleted = {fontSize:fontSize}
        const circleUncompleted = {width:"20px", height:"20px", fontSize:fontCircleSize}
        const circleCompleted = {width:"20px", height:"20px", fontSize:fontCircleSize, borderColor:"rgb(33, 150, 243)"}
        const circleActive = {width:"20px", height:"20px", fontSize:fontCircleSize, borderColor:"rgb(33, 150, 243)",backgroundColor:"rgb(33, 150, 243)"}
        let _lineWidth = 0;
        if(!isNaN(parseInt(progress))){
            _progress = parseInt(progress);
            _lineWidth = parseInt(progress) / total;
        }
        if(_lineWidth > 1)
            _lineWidth = 1;
        _lineWidth = (_lineWidth*100) +"%";
        let _textStyles = [];
        let _circleStyles = [];
        for(let i=1;i<=total;i++){
            if(finished){
                _circleStyles.push(circleCompleted);
                _textStyles.push(fontCompleted);
            }
            else if(i < progress){
                _circleStyles.push(circleCompleted);
                _textStyles.push(fontCompleted);
            }else if(i === progress){
                _circleStyles.push(circleActive);
                _textStyles.push(fontCompleted);
            }else{
                _circleStyles.push(circleUncompleted);
                _textStyles.push(fontUncompleted);
            }
        }
        setLineWidth(_lineWidth);
        setCircleStyles(_circleStyles);
        setTextStyles(_textStyles);
    }, [progress, steps]);

    return (
        <>
        <div className="react-form-wizard md horizontal" {...props}>
            <div className="wizard-navigation">
                <div className="wizard-progress-with-circle" style={{top:"15px"}}>
                    <div className="wizard-progress-bar" style={{backgroundColor: "rgb(33, 150, 243)", color:"rgb(33, 150, 243)", width:lineWidth}}></div>
                </div>
                <ul className="form-wizard-steps  wizard-nav wizard-nav-pills  md">
                    {steps.map((step,index) => {
                        return (
                            <li key={"pbar"+step+index}>
                                <a>
                                    <div className="wizard-icon-circle md checked" style={circleStyles.length > 0 ? circleStyles[index] : {width:"20px", height:"20px", fontSize:"0.5rem"}}>
                                        <div className="wizard-icon-container ">
                                            <span className="wizard-icon"></span>
                                        </div>
                                    </div>
                                    <span className="stepTitle" style={textStyles.length > 0 ? textStyles[index] :  {fontSize:fontSize}}>{step}</span>
                                </a>
                            </li>
                        )
                    })}
                    {/*<li>
                        <a>
                            <div className="wizard-icon-circle md checked" style={circleStyles.length > 0 ? circleStyles[0] : {width:"20px", height:"20px", fontSize:"0.5rem"}}>
                                <div className="wizard-icon-container ">
                                    <span className="wizard-icon"></span>
                                </div>
                            </div>
                            <span className="stepTitle" style={textStyles.length > 0 ? textStyles[0] :  {fontSize:fontSize}}>Invoice</span>
                        </a>
                    </li>
                    <li className="active">
                        <a>
                            <div className="wizard-icon-circle md checked" style={circleStyles.length > 0 ? circleStyles[1] : {width:"20px", height:"20px", fontSize:"0.5rem"}}>
                                <div className="wizard-icon-container ">
                                    <span className="wizard-icon"></span>
                                </div>
                            </div>
                            <span className="stepTitle " style={textStyles.length > 0 ? textStyles[1] :  {fontSize:fontSize}}>Steps</span>
                        </a>
                    </li>
                    <li>
                        <a>
                            <div className="wizard-icon-circle md checked" style={circleStyles.length > 0 ? circleStyles[2] : {width:"20px", height:"20px", fontSize:"0.5rem"}}>
                                <div className="wizard-icon-container ">
                                    <span className="wizard-icon"></span>
                                </div>
                            </div>
                            <span className="stepTitle " style={textStyles.length > 0 ? textStyles[2] :  {fontSize:fontSize}}>Documents</span>
                        </a>
                    </li>
                    <li>
                        <a>
                            <div className="wizard-icon-circle md checked" style={circleStyles.length > 0 ? circleStyles[3] : {width:"20px", height:"20px", fontSize:"0.5rem"}}>
                                <div className="wizard-icon-container ">
                                    <span className="wizard-icon"></span>
                                </div>
                            </div>
                            <span className="stepTitle " style={textStyles.length > 0 ? textStyles[3] :  {fontSize:fontSize}}>Execute</span>
                        </a>
                    </li>
                    <li>
                        <a>
                            <div className="wizard-icon-circle md checked" style={circleStyles.length > 0 ? circleStyles[4] : {width:"20px", height:"20px", fontSize:"0.5rem"}}>
                                <div className="wizard-icon-container ">
                                    <span className="wizard-icon"></span>
                                </div>
                            </div>
                            <span className="stepTitle " style={textStyles.length > 0 ? textStyles[4] :  {fontSize:fontSize}}>Complexity</span>
                        </a>
                </li>*/}
                </ul>
            </div>
        </div>
        </>
    )
}

export default TinyProgressBar;